'use client';

import { useParams, usePathname } from 'next/navigation';
import { NotFoundScreen } from '@/components/system/NotFoundScreen';

export default function TutorNotFound() {
  const { tutor: tutorUsername } = useParams<{ tutor: string }>();
  const pathname = usePathname();
  // A missing page under a provider sends you to that provider; a missing
  // provider has nowhere of their own to send you.
  const onRoot = pathname === `/${tutorUsername}`;

  return (
    <NotFoundScreen
      href={onRoot ? '/' : `/${tutorUsername}`}
      label={onRoot ? 'Back to main' : `Back to ${tutorUsername}`}
    />
  );
}
